import React from 'react'
import cx from 'classnames'
import { BtnV2, l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { billing, UpgradeSource } from 'common/billing'
import { PostMigrationToNewBillingModal } from 'common/billing/components/PostMigrationToNewBillingModal/PostMigrationToNewBillingModal'
import { TouchedContactLimits } from 'common/billing/constants/TouchedContactLimits'
import { getActiveContacts } from 'common/billing/entities/billingVersions/selectors'
import { Ability } from 'common/core/constants/Ability'
import { useDidMountEffect } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const PostMigrationFreeUsersToNewBillingNotification = () => {
  const activeContacts = useAppSelector(getActiveContacts)

  const promotePro = activeContacts > TouchedContactLimits.essential
  const abilities = promotePro ? [Ability.PAYMENT_INTEGRATIONS] : [Ability.PAID_AUTOMATIONS]

  useDidMountEffect(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.POST_MIGRATION_FREE_USERS_TO_NEW_BILLING.SHOWN')
  })

  const handleCTAClick = () => {
    analyticsService.sendEvent(
      'NOTIFICATION_BAR.POST_MIGRATION_FREE_USERS_TO_NEW_BILLING.CTA.CLICKED',
    )
    billing.requestUpgrade({
      source: UpgradeSource.POST_MIGRATION_FREE_USERS_TO_NEW_BILLING_MODAL,
      abilities,
    })
  }

  const handleOpenModalClick = () => {
    analyticsService.sendEvent(
      'NOTIFICATION_BAR.POST_MIGRATION_FREE_USERS_TO_NEW_BILLING.SEE_CHANGES.CLICKED',
    )
    billing.requestUpgrade({
      source: UpgradeSource.POST_MIGRATION_FREE_USERS_TO_NEW_BILLING_MODAL,
      abilities,
      paywall: billing.paywalls.universal(PostMigrationToNewBillingModal),
    })
  }

  return (
    <>
      <span>
        {promotePro
          ? l.translate(
              `We've updated your plan. Upgrade to Pro to get more Active Contacts and boost engagement.`,
            )
          : l.translate(
              `We've updated your plan. Don’t miss out on 3 months of Essential for free! Limited time offer.`,
            )}
      </span>
      <BtnV2 variant="success" onClick={handleCTAClick} className="m-l-sm">
        {promotePro ? l.translate('Try 14 days for free') : l.translate('Try 3 months for free')}
      </BtnV2>
      <BtnV2
        variant="ghost-primary"
        onClick={handleOpenModalClick}
        className={cx(cm.viewPricing, 'm-l-sm')}
      >
        {l.translate('See changes')}
      </BtnV2>
    </>
  )
}
